import Chart from 'react-apexcharts';
import { Skeleton, Grid, Switch, FormGroup, FormControlLabel, Tab, Tabs, Stack } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useGetTrackStatsQuery } from '../../../api/trackApiSlice'
import { useGetAlbumTracksQuery } from '../../../api/albumApiSlice'
import moment from 'moment';
// import { useSelector } from 'react-redux';
// import { selectCurrentStyle } from '../../../actions/discoverSlice';
import { useMemo, useState } from 'react';
// import { LineChart } from '@mui/x-charts';


const AlbumStats = () => {
    let { id } = useParams()
    // const selectedStyle = useSelector(selectCurrentStyle)
    const [checked, setChecked] = useState(false)
    const [sCountry, setSCountry] = useState('FR')
    const [style, setStyle] = useState('Général')

    const {
        data: tracks
    } = useGetAlbumTracksQuery({id})

    const {
        data: trackStats,
    } = useGetTrackStatsQuery(tracks && tracks.length > 0 ? tracks.map( trackLiked => trackLiked.track._id) : null)

    const handleChange = (event) => {
        setChecked(event.target.checked)
    }

    const handleChangeCountry = (event, newValue) => {
        if (trackStats.map( ts => ts?.stats?.filter( s => s.style === style && s.country === newValue).length).reduce((partialSum, a) => partialSum + a, 0) === 0)
        { setStyle([...new Set(trackStats.map(trackStat => trackStat.stats).flat().map( stat => stat.style ))][0]) }

        setSCountry(newValue)
    }

    const handleChangeStyle = (event, newValue) => {
        if (trackStats.map( ts => ts?.stats?.filter( s => s.style === newValue && s.country === sCountry).length).reduce((partialSum, a) => partialSum + a, 0) === 0)
        { setSCountry([...new Set(trackStats.map(trackStat => trackStat.stats).flat().map( stat => stat.country ))][0]) }
        
        setStyle(newValue)
    }

    const allStyle = useMemo(() => {
        if (!trackStats || !trackStats[0].stats)
            return []

        var styles = [...new Set(trackStats.map(trackStat => trackStat.stats).flat().map( stat => stat.style ))]
        setStyle(styles[0])

        return styles
    }, [trackStats])

    const allCountry = useMemo(() => {
        if (!trackStats || !trackStats[0].stats)
            return []

        var countries = [...new Set(trackStats.map(trackStat => trackStat.stats).flat().map( stat => stat.country ))]
        setSCountry(countries[0])

        return countries
    }, [trackStats])

    const statsByStyle = useMemo(() => {
        if (!trackStats || !trackStats[0].stats)
            return []

        // var statsCount = Math.max(...trackStats.map(trackStat => Math.max(...allStyle.map( style => 
        //     Math.max(...allCountry.map( country =>
        //         trackStat.stats.filter( stat => stat.style === style && stat.country === country).length)
        //     )
        // ))))

        var sortByStyle =  allStyle.map( (style, i) => {
            return { 
                style: style, 
                statsByCountry: allCountry.map( (country, y) => { return {
                    country: country, 
                    statsByTrack: trackStats.map( trackStat => {
                        var statFiltered = trackStat.stats.filter( stat => stat.style === style && stat.country === country)
                        if(statFiltered.length > 0) return {
                            track_id: trackStat.track_id,
                            stats: statFiltered
                        }
                        else return []
                    }).filter(stat => stat.stats && stat.stats.length > 0)
            }} ).filter(stat => stat.statsByTrack && stat.statsByTrack.length > 0) }
        })

        var filterByStyle = sortByStyle
        .filter(statByStyle => statByStyle.style === style)

        return filterByStyle[0]?.statsByCountry?.filter(statByCountry => statByCountry.country === sCountry && statByCountry.statsByTrack.length > 0 ).sort( (a, b) => a.date - b.date )[0]

    }, [trackStats, style, sCountry, allCountry, allStyle])

    // console.log(trackStats.map( ts => ts?.stats?.filter( s => s.style === style && s.country === 'ES').length).reduce((partialSum, a) => partialSum + a, 0))

    return tracks && tracks.length > 0 && statsByStyle?.country !== null && statsByStyle?.statsByTrack?.length > 0
    ?  
        <Grid key={'uyu'} size={12} sx={{overflow: 'hidden', height: '100%', width: '100%'}}> 
            <Stack direction={'row'} sx={{width: '100%'}}>
                <Tabs textColor='secondary' indicatorColor='secondary' value={sCountry} onChange={handleChangeCountry} aria-label="country tabs" sx={{overflowX: 'scroll'}} >
                    { allCountry.filter(country => trackStats.map( ts => ts?.stats?.filter( s => s.style === style && s.country === country).length).reduce((partialSum, a) => partialSum + a, 0) > 0).map( (sbCounry, i) => <Tab key={i} value={sbCounry} label={sbCounry} sx={{color: 'white!important', minWidth: '50px' }} />) }
                </Tabs>
                <Tabs textColor='secondary' indicatorColor='secondary' value={style} onChange={handleChangeStyle} aria-label="style tabs" sx={{overflowX: 'scroll'}}>
                    { allStyle.map( (style, i) => <Tab key={i} value={style} label={style} sx={{color: 'white!important'}} />) }
                </Tabs>
            </Stack>
            <Chart 
                options={{
                    grid: {
                        show: false
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    markers: {
                        size: 1,
                    },
                    theme: {
                        mode: 'dark', 
                        monochrome: {
                            enabled: true,
                            color: '#08088A',
                            shadeTo: 'light',
                            shadeIntensity: 0.65
                        }
                    },
                    chart: {
                        id: 'apexchart-example',
                        foreColor: '#FFFFFF',
                        background: '#ffffff00',
                        toolbar: {
                            show: false
                        },
                        animations: {
                            enabled: false,
                            easing: 'easeinout',
                            speed: 50,
                            animateGradually: {
                                enabled: true,
                                delay: 25
                            },
                            dynamicAnimation: {
                                enabled: true,
                                speed: 350
                            }
                        }
                    },
                    yaxis: {
                        min: 1,
                        max: 200,//Math.max(200, Math.max(...[...statsByStyle?.statsByTrack?.map(trackStat => trackStat?.stats?.map( stat => stat.position ))].flat())),
                        reversed: true,
                        position: 'right',
                        tickAmount: 10,
                        labels: {
                            formatter: function(val, index) {
                                return val.toFixed(0)
                            }
                        }
                    },
                    xaxis: {
                        tickAmount: 10,
                        position: 'top',
                        categories: [...new Set(statsByStyle?.statsByTrack?.map(stat => stat.stats).flat().sort((a, b) => new Date(a) - new Date(b)).map( stat => moment(stat.date).format('DD/MM/YY')))],
                        labels: {
                            rotate: 0
                        }
                    },
                    legend: {
                        show: checked
                    },
                    
                    }} 
                    series={
                        statsByStyle?.statsByTrack?.map( trackStat => {
                            trackStat.name = tracks.find( track => track.track._id === trackStat.track_id)?.track.apple_title
                            trackStat.data = trackStat.stats.map( stat => stat.position )
                            return trackStat
                        })
                    }
                    type="line" 
                    width={'100%'} 
                    height={'90%'} 
            />     
            <FormGroup sx={{m:1, position: 'absolute', right: 0, bottom: 0}}>
                <FormControlLabel
                control={
                    <Switch 
                        color='secondary'
                        checked={checked}
                        onChange={handleChange}
                        inputProps={{ 'aria-label': 'controlled' }} />
                }
                label="Afficher la légende"
                />
            </FormGroup>  
        </Grid>
    :   <Skeleton variant="rectangular" width={'100%'} height={'100%'} />
}

export default AlbumStats
